// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__38HBt","footer":"ReportModalFilter_footer__3PQaR"};